import { N53 } from "./CustomerGroupSalesWithGrowth/N53";
import { N27 } from "./SalesByChannelLastYearVSActualSales/N27";

export const ExecutiveRegionGrowthPerformance = {
  "sections": [
    N53,
    N27
  ]
}